import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSection } from 'store/useBusinessToolStore/selectors';

import { useBusinessToolAiContext } from '../useBusinessToolAiContext';

export const useAIActionHandler = () => {
  const { isLoading, cancelSectionAI, isWholeDocumentLoading, cancelWholeDocumentAI } = useBusinessToolAiContext();

  const activeSection = useBusinessToolStore(getActiveSection);

  const handleStop = (action?: VoidFunction) => {
    if (isWholeDocumentLoading) {
      cancelWholeDocumentAI(action);
      return;
    }

    cancelSectionAI({ sectionKey: activeSection, onConfirmCallback: action });
  };

  const handleActionWithAICheck = (action?: VoidFunction) => {
    if (isWholeDocumentLoading) {
      cancelWholeDocumentAI(action);
      return;
    }
    if (isLoading) {
      cancelSectionAI({ sectionKey: activeSection, onConfirmCallback: action });
      return;
    }
    if (action) {
      action();
    }
  };

  return { handleActionWithAICheck, onAiGenerationStop: handleStop };
};
